/**
 * useEnsureWebFonts — React bridge for ensureWebFontsLoaded
 *
 * Injects the given web fonts into document.head after mount / whenever
 * the asset set actually changes (keyed by id+weights, not array identity,
 * so unmemoized callers don't re-trigger). No-ops on SSR and empty sets.
 *
 * @module font-config/hooks
 */

import { useEffect } from 'react';
import type { WebFontAsset } from '../types/fontConfig.types';
import { ensureWebFontsLoaded } from '../utils/ensureWebFontsLoaded';

export function useEnsureWebFonts(assets: WebFontAsset[] | undefined): void {
  const assetsKey = assets
    ?.map((asset) => `${asset.id}:${asset.weights.join('_')}`)
    .join('|') ?? '';

  useEffect(() => {
    if (assets?.length) ensureWebFontsLoaded(assets);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [assetsKey]);
}
